import { BadgeCheck, CloudDownload, FolderTree, Globe, LayoutList, MessageSquareQuote, Route, Sparkles, TrendingUp, UsersRound } from "lucide-react";
import { useEffect, useState } from "react";

const items = [
  {
    text: "Loading your cluster prompts…",
    icon: <FolderTree />,
  },
  {
    text: "Pulling the latest AI answers for this cluster…",
    icon: <CloudDownload />,
  },
  {
    text: "Detecting which brands get recommended…",
    icon: <Sparkles />,
  },
  {
    text: "Calculating your visibility and average position…",
    icon: <TrendingUp />,
  },
  {
    text: "Extracting cited sources from AI responses…",
    icon: <MessageSquareQuote />,
  },
  {
    text: "Classifying source pages (listicles, comparisons, directories)…",
    icon: <LayoutList />,
  },
  {
    text: "Aggregating top cited domains and source types…",
    icon:  <Globe />,
  },
  {
    text: "Building your competitor snapshot for this cluster…",
    icon: <UsersRound />,
  },
  {
    text: "Generating your 30–60 day action plan and evidence…",
    icon: <Route />,
  },
  {
    text: "Formatting your strategy page and final checks…",
    icon: <BadgeCheck />,
  },
];

export default function RotatingText() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % items.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="overflow-hidden h-[225px] -mt-[45px]">
      <div
        className="transition-transform gap-4 flex flex-col duration-700 ease-in-out"
        style={{
          transform: `translateY(calc(-${index * 3.5}rem + 3.5rem))`,
        }}
      >
        {items.map((item, i) => {
          const isActive = i === index;
          const isBelow = i > index; 
          const isAbove = i < index; 

          return (
            <div
              key={i}
              className="h-10 flex gap-1 flex-col text-[#737373] flex text-sm items-center justify-center transition-all duration-500"
              style={{
                opacity: isActive ? 1 : isBelow ? 0.4 : 0,
                transform: isActive
                  ? "scale(1)"
                  : isBelow
                    ? "scale(0.95)"
                    : "scale(0.9)",
                visibility: isAbove ? "hidden" : "visible",
              }}
            >
               {item.icon}
              {item.text}
            </div>
          );
        })}
      </div>
    </div>
  );
}
